





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyDetails from '@/components/Agencies/AgencyDetails.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyProfileSettings',
  	components: { AgencyDetails, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getAgency();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingAgency;
  	}
}
